import styled, { css } from 'styled-components'

import { font } from '~/styles/utils'

export const StepsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  & a {
    width: inherit;
    margin: 0;
    padding: 0;
  }
`

export const StepWrapper = styled.div<{
  $isLastStep: boolean
}>`
  position: relative;
  flex-grow: 1;

  ${({ $isLastStep }) =>
    !$isLastStep &&
    css`
      &:after {
        content: ' ';
        width: calc(100% - 53px);
        height: 2px;
        background-color: ${({ theme }) => theme.color.background.dark};
        position: absolute;
        top: 22px;
        left: 62px;
      }
    `};

  ${({ $isLastStep }) =>
    $isLastStep &&
    css`
      flex-grow: 0;
      &:after {
        content: none;
      }
    `};
`

export const Content = styled.div`
  width: 72px;
  color: ${({ theme }) => theme.color.text.default};
`

export const IconWrapper = styled.span<{
  $isCurrentStep: boolean
}>`
  position: relative;
  margin: 0 14px;
  width: 32px;
  height: 32px;
  text-align: center;
  display: block;
  border: solid 2px ${({ theme }) => theme.color.border.onDark};
  border-radius: 50%;
  background: ${({ theme }) => theme.color.background.dark};
  border-color: ${({ theme }) => theme.color.border.dark};
  color: ${({ theme }) => theme.color.text.onDark};

  ${({ $isCurrentStep }) =>
    $isCurrentStep &&
    css`
      background: ${({ theme }) => theme.color.background.accent};
      border-color: ${({ theme }) => theme.color.background.accent};
      color: ${({ theme }) => theme.color.icon.default};
    `};

  > * {
    position: relative;
    font-size: 14px;
  }

  /* Position icons within their wrapper */
  .fa-user {
    top: 7px;
  }

  .fa-tag {
    top: 7px;
    left: 1px;
  }

  .fa-credit-card {
    top: 7px;
  }

  .fa-check {
    top: 7px;
  }
`

export const Subtitle = styled.span`
  ${font('bold')};
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 8px;
  display: block;
  color: ${({ theme }) => theme.color.text.default};
`
